import React, { useState, useEffect } from "react";
import {
  MdInsights,
  MdTrendingUp,
  MdNavigation,
  MdGavel,
  MdOutlineAutoGraph,
  MdSettingsSuggest
} from "react-icons/md";
import "./HumanexAICompanion.css";

const FEATURES = [
  {
    // tag: "Insights",
    icon: <MdInsights />,
    titleRed: "Data",
    titleBlack: "Analyzer",
    desc:
      "Humanex transforms complex HR data into clear insights. Ask questions in plain language and act with confidence."
  },
  {
    // tag: "Performance",
    icon: <MdTrendingUp />,
    titleRed: "Growth",
    titleBlack: "Coach",
    desc:
      "Humanex provides thoughtful, data-driven feedback aligned with your people strategy and company culture."
  },
  {
    // tag: "Navigation",
    icon: <MdNavigation />,
    titleRed: "Product",
    titleBlack: "Navigator",
    desc:
      "Let Humanex guide you instantly to the right tools, reports, and settings — no clicks, no searching."
  },
  {
    // tag: "Compliance",
    icon: <MdGavel />,
    titleRed: "Compliance",
    titleBlack: "Advisor",
    desc:
      "Stay compliant with automated policy guidance and real-time regulatory updates."
  },
  {
    // tag: "Analytics",
    icon: <MdOutlineAutoGraph />,
    titleRed: "People",
    titleBlack: "Analyst",
    desc:
      "Understand engagement, retention, and workforce trends with AI-powered analytics."
  },
  {
    // tag: "Automation",
    icon: <MdSettingsSuggest />,
    titleRed: "Workflow",
    titleBlack: "Automator",
    desc:
      "Automate repetitive HR tasks and approvals with intelligent workflows."
  }
];

// duplicate for infinite illusion
const SLIDES = [...FEATURES, ...FEATURES];

const HumanexAICompanion = () => {
  const [index, setIndex] = useState(0);
  const [animate, setAnimate] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => prev + 1);
    }, 2800);
    return () => clearInterval(interval);
  }, []);

  // silent reset (no flicker, no reverse)
  useEffect(() => {
    if (index === FEATURES.length) {
      setTimeout(() => {
        setAnimate(false);
        setIndex(0);
      }, 600);
    } else {
      setAnimate(true);
    }
  }, [index]);

  return (
    <section className="humanex-wrapper">
      <div className="humanex-header">
        <h2 className="humanex-heading">
          ✦ Meet the <span className="humanex-highlight">Humanex AI</span> Companion
        </h2>
        <p>
          Your AI assistant securely connects to HR data to deliver sharper
          insights and faster decisions.
        </p>
      </div>

      <div className="humanex-slider">
        <div
          className={`humanex-track ${animate ? "animate" : ""}`}
          style={{ transform: `translateX(-${index * 33.333}%)` }}
        >
          {SLIDES.map((item, i) => (
            <div
              key={i}
              className={`humanex-card ${
                i % FEATURES.length === index % FEATURES.length ? "active" : ""
              }`}
            >
              <div className="humanex-icon">{item.icon}</div>

              <div className="humanex-chip">{item.tag}</div>

              <h3 className="humanex-title">
                <span className="red">{item.titleRed}</span>{" "}
                <span className="black">{item.titleBlack}</span>
              </h3>

              <div className="humanex-divider" />
              <p>{item.desc}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="humanex-pagination">
        {FEATURES.map((_, i) => (
          <span
            key={i}
            className={`dot ${i === index % FEATURES.length ? "active" : ""}`}
          />
        ))}
      </div>
    </section>
  );
};

export default HumanexAICompanion;
